import '../sass/image-carousel.scss';

(() => {
    const swiperScript = document.querySelector('#blenheim-schools-swiper-js');
    const $blocks = document.querySelectorAll('.block.image-carousel');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.image-carousel__carousel');
        const $carouselNavigationPrev = $block.querySelector('.image-carousel__controls-navigation--prev');
        const $carouselNavigationNext = $block.querySelector('.image-carousel__controls-navigation--next');

        const initCarousels = () => {
            if (!$carousel) return;

            const setSlidesOffsetAfter = carousel => {
                if (!carousel) return;

                if (window.innerWidth >= 768) {
                    carousel.params.slidesOffsetAfter = carousel.width - 406;
                } else {
                    carousel.params.slidesOffsetAfter = 0;
                }
            }

            new Swiper($carousel, {
                loop: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                navigation: {
                    prevEl: $carouselNavigationPrev,
                    nextEl: $carouselNavigationNext,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        loop: false,
                        spaceBetween: 30,
                    },
                },
                on: {
                    init: function () {
                        setSlidesOffsetAfter(this);
                    },
                    resize: function () {
                        setSlidesOffsetAfter(this);
                    }
                }
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousels();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousels();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#blenheim-schools-swiper-js');

                if (!swiperScript) return;

                initCarousels();
            });
        }
    });
})();
